import { useQuery } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export const getCustomInquiry = async (): Promise<any> => {
    const { data } = await axios.get(`v1/admin/inquiries/get-careers-inquiries`);
    return data;
};

type QueryFnType = typeof getCustomInquiry;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useCustomInquiry = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['customInquiry'],
        queryFn: () => getCustomInquiry(),
    });
};
